import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { CommonLayout } from "../components/CommonLayout";
import { Practices } from "components/Practices";
import { Buttons } from "components/Buttons";
import { Referrals } from "components/Referrals";
import { ReferralDetails } from "components/ReferralDetails";
import { Profile } from "components/Profile";
import { ReactComponent as ReferralsIcon } from "images/referrals-icon.svg";
import { ReactComponent as PracticesIcon } from "images/practices-icon.svg";
import { ReactComponent as OriginatorsIcon } from "images/originators-icon.svg";
import { ReactComponent as ButtonsIcon } from "images/buttons-icon.svg";
import { ReactComponent as SpecialistsIcon } from "images/specialists-icon.svg";
import { MyOrganizationDetails } from "components/MyOrganizationDetails";
import { Regions } from "components/Regions";
import { MyButtons } from "components/MyButtons";
import { UnsubscribePage } from "components/UnsubscribePage";
import { PracticeDetails } from "components/PracticeDetails";
import { Senders } from "components/Senders";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <CommonLayout
        menu={[
          {
            label: "Referral Stream",
            path: "/",
            Icon: ReferralsIcon,
          },
          { label: "Practices", path: "/practices", Icon: PracticesIcon },
          {
            label: "Senders",
            path: "/senders",
            Icon: OriginatorsIcon,
          },
          {
            label: "Buttons",
            path: "/button_locations",
            Icon: ButtonsIcon,
          },
          {
            label: "My Organization",
            Icon: SpecialistsIcon,
            subItems: [
              { label: "Organization Profile", path: "/my_organization_details" },
              { label: "Regions", path: "/regions" },
            ],
          },
        ]}
      />
    ),
    children: [
      {
        path: "/",
        element: <Referrals />,
      },
      {
        path: "/button_locations",
        element: <Buttons />,
      },
      {
        path: "/my_button_dashboard",
        element: <MyButtons />,
      },
      {
        path: "/unsubscribe/:token",
        element: <UnsubscribePage />,
      },
      {
        path: "/practices",
        element: <Practices />,
      },
      {
        path: "/practice/:id",
        element: <PracticeDetails />,
      },
      {
        path: "/regions",
        element: <Regions />,
      },
      {
        path: "/senders",
        element: <Senders />,
      },
      {
        path: "/my_organization_details",
        element: <MyOrganizationDetails />,
      },
      {
        path: "/referral/:id",
        element: <ReferralDetails />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export const Marketer = () => <RouterProvider router={router} />;
